import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { SNModal } from '@web-services/modal/snModal.interfaces';

@Component({
	selector: 'confirm-re-sync-modal',
	template: require('./confirm-re-sync-modal.html'),
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmReSyncModal implements SNModal {
	btnDisabled: boolean;

	constructor(
		public activeModal: NgbActiveModal,
		private modalService: SNModalService
	) {}

	onSubmit(): void {
		this.btnDisabled = true;
		this.modalService.setModalData(true);
	}

	onDismiss(): void {
		this.activeModal.dismiss();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/date-time-calendar/confirm-re-sync-modal/confirm-re-sync-modal.ts